module.exports = __webpack_public_path__ + "img/tips.7fa2c119.png";